<div *ngIf="currentUser != undefined" id="sidr-main" class="vertical-menu">
  <div class="nav-close"></div>
  <ul class="menu-list">
    <li class="user-wrapper">
      <div class="user-avatar">
        <img id="img-user" src="assets/img/no-avatar.jpg" alt="" />
      </div>
      <div class="user-info">
        <h3 id="fullname" data-code="">{{ currentUser.username }}</h3>
      </div>
    </li>
    <li class="logout" id="logout">
      <a (click)="signOut()">Đăng xuất</a>
    </li>
    <li *ngIf="currentUser.role == 'Master' || currentUser.role == 'Super'">
      <a (click)="exportReport()">Xuất báo cáo</a>
    </li>
  </ul>
  <div class="sidr-overlay"></div>
</div>
<div class="overlay overlay-inner outer" id="globalSpiner">
  <div class="inner">
    <div class="spinner"></div>
  </div>
</div>
<div id="popup-check-logout" class="popup-overlay modal-confirm confirm-fail">
  <div class="popup-warp">
    <div class="popup-inner pad-popup">
      <div class="content-popup">
        <div class="icon-popup"><img src="assets/img/unilever-icon.png" /></div>
        <p class="des-popup" [innerHtml]="errormassage | safeHtml"></p>
        <div class="group-btn-inline btn-center">
          <button
            type="button"
            class="btn btn-primary"
            id="close-modal"
            (click)="hidePopup()"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="popup-network-error" class="popup-overlay modal-confirm confirm-fail hidden">
  <div class="popup-warp">
    <div class="popup-inner pad-popup">
      <div class="content-popup">
        <div class="icon-popup"><img src="assets/img/unilever-icon.png" /></div>
        <p class="des-popup" >
           Đã có lỗi xảy ra. <br />
          Vui lòng kiểm tra kết nối mạng và thử lại
        </p>
        <div class="group-btn-inline btn-center">
          <button
            type="button"
            class="btn btn-primary"
            id="close-modal"
            (click)="hideNetworkPopup()"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="popup-expire-token" class="popup-overlay modal-confirm confirm-fail hidden">
  <div class="popup-warp">
    <div class="popup-inner pad-popup">
      <div class="content-popup">
        <div class="icon-popup"><img src="assets/img/unilever-icon.png" /></div>
        <p class="des-popup" >
          Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại
        </p>
        <div class="group-btn-inline btn-center">
          <button
            type="button"
            class="btn btn-primary"
            id="close-modal"
            (click)="hideTokenPopup()"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  id="popup-check-campaignactive"
  class="popup-overlay modal-confirm confirm-fail"
>
  <div class="popup-warp">
    <div class="popup-inner pad-popup">
      <div class="content-popup">
        <div class="icon-popup"><img src="assets/img/unilever-icon.png" /></div>
        <p class="des-popup" [innerHtml]="errormassage1 | safeHtml"></p>
        <div class="group-btn-inline btn-center">
          <button
            type="button"
            class="btn btn-primary"
            id="close-modal"
            (click)="hidePopup1()"
          >
            Đóng
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="main-content landing-desktop" *ngIf="!supportedDevice">
  <div class="left-main">
    <a href="/"
      ><img class="logo" [src]="'assets/img/desk-logo.png'" alt="images"
    /></a>
    <p>
      Scan mã QR<br />
      bằng điện thoại để<br />
      tham gia mua hàng đổi quà!!!
    </p>
    <div class="qrCode">
      <img class="qr" [src]="'assets/img/desk-qr.png'" alt="images" />
    </div>
    <ul>
      <li>
        <a
          href="javascript:window.open('https://www.unilever.com.vn/legal.html')"
          >Thông báo pháp lý</a
        >
      </li>
      <li>
        <a
          href="javascript:window.open(window.origin+'/assets/dieukhoan/thele20220930.pdf')"
          >Thể lệ & Điều khoản sử dụng</a
        >
      </li>
      <li>
        <a
          class="policy"
          target="_blank"
          href="https://www.unilevernotices.com/vietnam/vietnamese/privacy-notice/notice.html"
          >Chính sách bảo mật</a
        >
      </li>
      <li>
        <a
          class="policy"
          target="_blank"
          href="https://notices.unilever.com/vn/corporate/?_gl=1*wrws7b*_ga*MTYwOTA4NzY0NS4xNjkyNjcxODQz*_ga_YD4H91RBTJ*MTY5NDA2OTc1Ny4yLjEuMTY5NDA2OTg5OC4wLjAuMA.."
          >Khả Năng Truy Cập</a
        >
      </li>
      <li><a class="policy" href="tel:1900633415">Hotline: 1900 633 415</a></li>
    </ul>
    <p class="noteps">
      Bản quyền thuộc Công ty TNHH Quốc tế Unilever Việt Nam <br />&copy;
      Unilever 2023
    </p>
  </div>
  <div class="right-main"></div>
</div>
<router-outlet id="main-content" *ngIf="supportedDevice"></router-outlet>
